import 'babel-polyfill';

import '../../stylesheets/market/index.less';
// import 'mapbox-gl/dist/mapbox-gl.css';

import angular from 'angular';

import { includes } from 'lodash';

module.exports = angular.module('market', [
  require('angular-cookies'),
  require('angular-marked'),
  require('angular-swipe'),
  require('checklist-model'),
  require('common/module'),
  require('ng-meta'),
  require('./components'),
  require('./controllers'),
  require('./deprecated'),
  require('./directives'),
  require('./mocks'),
  require('./models'),
  require('./routes'),
  require('./services'),
])
.run(function($rootScope, $state, Session, ngMeta) {
  $rootScope.session = Session.info();

  $rootScope.$on('$locationChangeSuccess', () => {
    let location = window.location;

    let adjustedPathname = {
      '/homepage': '/'
    }[location.pathname] || location.pathname;

    // handles /homes/:slug/buy/contact
    if (includes(adjustedPathname, '/buy/contact')) {
      adjustedPathname = adjustedPathname.replace('/buy/contact', '');
    }

    // page URL without query params, reasonable default
    let href = location.protocol + '//' + location.host + adjustedPathname;

    let canonicalTag = document.getElementById('canonical');
    if (!canonicalTag) {
      canonicalTag = document.createElement('link');
      canonicalTag.rel = 'canonical';
      canonicalTag.id = 'canonical';
      document.getElementsByTagName('head')[0].appendChild(canonicalTag);
    }
    canonicalTag.href = href;
  });
  $rootScope.$on('$stateChangeError', function(e, to, toParams, from, fromParams, error) {
    // without handling an error here, we render a blank page with no information for the user.
    // instead, redirect to the 404 page if the homes slug is not found or else render the 500 page.
    if (error && error.status === 404) {
      window.location.href = '/404';
    }
    else {
      window.location.href = '/500';
    }
  });
  $rootScope.$on('$stateChangeStart', function(evt, to, params) {
    // use replaceState instead of pushState when redirecting
    if (to.redirectTo) {
      evt.preventDefault();
      $state.go(to.redirectTo, params, { location: 'replace' });
    }
  });
  ngMeta.init();
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/module.js
 **/